module.exports = __webpack_public_path__ + "img/apptu4.11876618.png";